import { useEffect, useState } from "react";
import QRCode from "qrcode";
import { useRuntimeConstants } from "../../context/runtimeConstants/RuntimeConstantsContext";
import { getCustomerLoyaltyAccess } from "../../utils/loyalty/getCustomerLoyaltyAccess";
import { getFeature } from "../../utils/features";
import { CUSTOMER_ACCESS_PURCHASE } from "../../constants";
import { generateOneLinkURL } from "../../utils/oneLinkGenerator";
import styles from "./AppDownloadQrCode.scss";

const AppDownloadQrCode = () => {
  const { getTranslation, isMobile, product, webContext } =
    useRuntimeConstants();
  const { customerAccess } = getCustomerLoyaltyAccess(product);
  const isAppAdoptionEnabled = getFeature("eap-app-adoption").isEnabled();
  const generatedUrl = generateOneLinkURL(webContext, product);
  const [qrCodeDataUrl, setQrCodeDataUrl] = useState(null);

  const shouldRender =
    isAppAdoptionEnabled &&
    customerAccess === CUSTOMER_ACCESS_PURCHASE &&
    !isMobile;

  useEffect(() => {
    if (shouldRender) {
      QRCode.toDataURL(generatedUrl, {
        margin: 1,
        width: 100,
      }).then((url) => setQrCodeDataUrl(url));
    }
  }, [shouldRender, generatedUrl]);

  if (!shouldRender || !qrCodeDataUrl) return null;

  return (
    <div>
      <p className={styles.title}>
        {getTranslation("download_the_app_app_exclusive_title")}
      </p>
      <img src={qrCodeDataUrl} alt="" className={styles.qrCode} />
    </div>
  );
};

export default AppDownloadQrCode;
